import ProfileDelete from '@/screens/ProfileDelete';

export default function PrivateProfileAccountDeleteRoute() {
  return <ProfileDelete />;
}
